import { ActionTree } from 'vuex';
import { ZoomSignatureState } from './state';
import RootState from '@/store/root_state';
import { ErrorHandler } from '@/helpers/errorHandler';
import i18n from '../../../i18n';
import { MICROSERVICES_ENUM, graphqlQuery } from '@/helpers/apollo';
import { getZoomSignature } from '@/store/queries/westerosQueries';

export interface ZoomSignatureInput {
  meetingNumber: string;
  role: number;
}

const actions: ActionTree<ZoomSignatureState, RootState> = {
  async GET_ZOOM_SIGNATURE({ commit }, zoomSignatureInput: ZoomSignatureInput) {
    try {
      const { data } = await graphqlQuery(
        MICROSERVICES_ENUM.ENROLLMENTS,
        getZoomSignature,
        zoomSignatureInput,
      );

      const { signature } = data.zoomSignature;

      commit('SET_SIGNATURE', signature);
    } catch (error) {
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.tc('zoomAuthErrorMessage').toString(),
      });
    }
  },
};

export default actions;
